export const SET_RISKS = "SET_RISKS";
export const ADD_RISK = "ADD_RISK";
export const UPDATE_RISK = "UPDATE_RISK";
export const REMOVE_RISK = "REMOVE_RISK";
export const SELECT_RISK = "SELECT_RISK"